module.exports = __webpack_public_path__ + "static/012-a9c5e0e86f120af869df99a45b866107.jpg";